import React, { useEffect, useState, useCallback } from 'react';
import { Users } from 'lucide-react';
import api from '../utils/api';
import LeadTable from '../components/LeadTable';
import LeadDetail from '../components/LeadDetail';
import { useSearchParams } from 'react-router-dom';

export default function AllLeads() {
  const [leads, setLeads] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openLead, setOpenLead] = useState(null);
  useEffect(() => { const id = parseInt(searchParams.get('lead'), 10); if (id) { setOpenLead(id); setSearchParams({}, { replace: true }); } }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [filters, setFilters] = useState({ page: 1, search: '', status: '', qualification: '', city: '', category: '', source: '', utm_campaign: '' });

  const load = useCallback(async () => {
    try {
      const [res, dsRes] = await Promise.all([api.get('/leads', { params: filters }), api.get('/datasets')]);
      setLeads(res.data.leads); setTotal(res.data.total); setPages(res.data.pages); setDatasets(dsRes.data);
    } catch (err) { console.error(err); }
  }, [filters]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <Users size={24} color="var(--accent)" />
        <h1 style={{ fontSize: 26, fontWeight: 800 }}>Todos los Leads</h1>
      </div>
      <LeadTable leads={leads} total={total} page={filters.page} pages={pages} filters={filters} setFilters={setFilters} onRefresh={load} showDatasetCol={true} datasets={datasets} />
      {openLead && <LeadDetail leadId={openLead} onClose={() => { setOpenLead(null); load(); }} />}
    </div>
  );
}
